import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reference-dashboard',
  templateUrl: './reference-dashboard.component.html',
  styleUrls: ['./reference-dashboard.component.scss']
})
export class ReferenceDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
